import { useMemo } from 'react'
import { useFeatureFlags } from 'features/FeatureFlags'

import { DebitCardTransactionStatusV2 } from 'types/gql-global-types'
import { useAccountFilters } from 'layouts/AccountLayout/hooks/useAccountFilters/useAccountFilters'
import { ReceiptIncluded } from 'layouts/AccountLayout/hooks/useAccountFiltersValues/useAccountFiltersValues'

export const useGetOutstandingExpensesFilter = () => {
  const { receipt, status } = useAccountFilters()

  const flags = useFeatureFlags()

  const isOutstandingExpensesFilterOn = useMemo(() => {
    if (!flags.CorpCardsOutstandingTransactionsFilter) {
      return false
    }

    const isReceiptFilterOn =
      receipt.length === 1 && receipt[0] === ReceiptIncluded.NOT_INCLUDED
    const isApprovedStatusFilterOn = status
      ? status.length === 1 &&
        status[0] === DebitCardTransactionStatusV2.APPROVED
      : false

    return isReceiptFilterOn && isApprovedStatusFilterOn
  }, [receipt, flags.CorpCardsOutstandingTransactionsFilter, status])

  return {
    isOutstandingExpensesFilterOn,
  }
}
